/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface ReferencedEntityGuidDto
 */
export interface ReferencedEntityGuidDto {
    /**
     * 
     * @type {string}
     * @memberof ReferencedEntityGuidDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReferencedEntityGuidDto
     */
    $type?: ReferencedEntityGuidDtoTypeEnum;
}


/**
 * @export
 */
export const ReferencedEntityGuidDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoReferencedEntityGuidDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ReferencedEntityGuidDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ReferencedEntityGuidDtoTypeEnum = typeof ReferencedEntityGuidDtoTypeEnum[keyof typeof ReferencedEntityGuidDtoTypeEnum];


/**
 * Check if a given object implements the ReferencedEntityGuidDto interface.
 */
export function instanceOfReferencedEntityGuidDto(value?: unknown): value is ReferencedEntityGuidDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ReferencedEntityGuidDtoTypeEnum)[0];
}

export function ReferencedEntityGuidDtoFromJSON(json: any): ReferencedEntityGuidDto {
    return ReferencedEntityGuidDtoFromJSONTyped(json, false);
}

export function ReferencedEntityGuidDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferencedEntityGuidDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ReferencedEntityGuidDtoToJSON(value?: ReferencedEntityGuidDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        '$type': value.$type,
    });
}

